<form [formGroup]="registroActividadComercializacionFormGroup" *ngIf="(this.currentEmpresa$ | async) as currentEmpresa">
  <h5>Indicar los grupos de especies si comercializa semillas producidas por la empresa, semilla importada y/o reventa
    de semilla</h5>

  <!-- produccion -->
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-label required>
        ¿Comercializa semilla producida por la empresa {{ currentEmpresa.nombre }}?
      </mat-label>
    </div>
  </div>
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-radio-group aria-label="" required (change)="this.comSemProducida = $event.value">
        <mat-radio-button [checked]="comSemProducida" [value]=true>Sí</mat-radio-button>
        <mat-radio-button [checked]="!comSemProducida" [value]=false>No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="row" *ngIf="comSemProducida">
    <div *ngIf="actividadProduccion$ | async; then elegirComProd else agregarProd"></div>
    <ng-template #elegirComProd>
      <h6>Indicar los grupos de especies comercializados</h6>
      <rpe-check-list-form [formInput]="formInputSemProd" (formValueChanges)="semProdChange($event)"
        (formStatusChanges)="semProdStatusChange($event)"></rpe-check-list-form>
      <mat-hint>Nota: Se listan unicamente los grupos de especies registrados en la actividad de producción</mat-hint>
    </ng-template>
    <ng-template #agregarProd>
      <p>
        Para registrar comercialización de producción es necesario registrar previamente la actividad producción
      </p>
      <button type="button" mat-raised-button (click)="registrarActividad()" color="link">
        Registrar actividad producción
      </button>
    </ng-template>
  </div>
  <br>

  <!-- importacion -->
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-label required>
        ¿Comercializa semilla importada por la empresa {{ currentEmpresa.nombre }}?
      </mat-label>
    </div>
  </div>
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-radio-group aria-label="" required (change)="this.comSemImportada = $event.value">
        <mat-radio-button [checked]="comSemImportada" [value]=true>Sí</mat-radio-button>
        <mat-radio-button [checked]="!comSemImportada" [value]=false>No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="row" *ngIf="comSemImportada">
    <div *ngIf="actividadImportacion$ | async;then elegirComImp else agregarImp"></div>
    <ng-template #elegirComImp>
      <h6>Indicar los grupos de especies comercializadas</h6>
      <rpe-check-list-form [formInput]="formInputSemImp" (formValueChanges)="semImpChange($event)"
        (formStatusChanges)="semImpStatusChange($event)"></rpe-check-list-form>
      <mat-hint>Nota: Se listan unicamente los grupos de especies registrados en la actividad de produccion</mat-hint>
    </ng-template>
    <ng-template #agregarImp>
      <p>
        Para registrar comercialización de producción es necesario registrar previamente la actividad producción
      </p>
      <button type="button" mat-raised-button (click)="registrarActividad()" color="link">
        Registrar actividad importación
      </button>
    </ng-template>
  </div>
  <br>

  <!-- reventa -->
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-label required>
        ¿Realiza reventa de semilla?
      </mat-label>
    </div>
  </div>
  <div class="row">
    <div class="col" [ngClass]="routeAnimationsElements">
      <mat-radio-group aria-label="" required (change)="this.reventaSemilla = $event.value">
        <mat-radio-button [checked]="reventaSemilla" [value]=true>Sí</mat-radio-button>
        <mat-radio-button [checked]="!reventaSemilla" [value]=false>No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="row" *ngIf="reventaSemilla">
    <h6>Indicar los grupos de especies comercializadas</h6>
    <rpe-check-list-form [formInput]="formInputSemRev" (formValueChanges)="semRevChange($event)"
      (formStatusChanges)="semRevStatusChange($event)"></rpe-check-list-form>
  </div>
</form>
<div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
  <button (click)="onCancel()" mat-raised-button>
    {{ 'rpe.vista-usuario.volver' | translate }}
  </button>
  <button mat-raised-button (click)="onGuardar()" color="primary">
    {{ 'rpe.vista-usuario.guardar-y-continuar' | translate }}
  </button>
</div>